import { Button, Container, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Stack spacing={2} alignItems="flex-start">
        <Typography variant="h4" component="h1" fontWeight={700}>
          {t('errors.notFoundTitle')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('errors.notFoundDetail')}
        </Typography>
        <Button component={RouterLink} to="/" variant="contained">
          {t('common.backToFeed')}
        </Button>
      </Stack>
    </Container>
  );
}
